'use client';

import { useNuqsNextPagesRouterAdapter } from '../../chunk-ZJRAGNYE.js';
import { createAdapterProvider } from '../../chunk-5WWTJYGR.js';

// src/adapters/next/pages.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

export { NuqsAdapter };
